import { SdkConfig } from '@criptalia/sdk/src/Sdk'

const isProduction = window.location.host.endsWith('borseria.app')

const apiDomain = isProduction ? 'dive.api.corefi.co' : 'dive-staging.api.corefi.co'

export const API_URL = `https://${apiDomain}`

const websocketUrl = `wss://${apiDomain}/connection/websocket`

export const FRONTEND_ENV: SdkConfig['env'] = {
  isProduction,
  isProductionBuild: import.meta.env.PROD,
  websocketUrl,
  brandName: 'Borseria',
  datocmsToken:
    import.meta.env.VITE_DATO_CMS_TOKEN || '7a88e0a13688942caf5c48d5675a9b',
  mapsApiKey:
    import.meta.env.VITE_MAPS_API_KEY ||
    'AIzaSyB15ds5CBvNKu8VGdxMxKp7nVPPLYtqQkM',    
}
